// extracted by mini-css-extract-plugin
export default {"container":"ao-z","heading":"bo-z","text":"co-z","info":"do-z","link":"eo-z","fullMaxWidth":"fo-z"};